import { webp, jpeg, png } from '../data/image';

export const image = (data) => {
  let image;
  if (typeof data.image_jpeg !== 'undefined' && typeof data.image_jpeg.url !== 'undefined') {
    image = data.image_jpeg.url;
  } else if (typeof data.image_png !== 'undefined' && typeof data.image_png.url !== 'undefined') {
    image = data.image_png.url;
  }

  return image;
};

export const sources = (data) => {
  let webpSources = [];
  if (typeof data.image_webp !== 'undefined' && typeof data.image_webp.url !== 'undefined') {
    webpSources = webp.map((source, i) => {
      return {media: source.media, srcset: data.image_webp[source.id].url, type: source.type};
    });
  }
  let jpegSources = [];
  if (typeof data.image_jpeg !== 'undefined' && typeof data.image_jpeg.url !== 'undefined') {
    jpegSources = jpeg.map((source, i) => {
      return {media: source.media, srcset: data.image_jpeg[source.id].url, type: source.type};
    });
  }
  let pngSources = [];
  if (typeof data.image_png !== 'undefined' && typeof data.image_png.url !== 'undefined') {
    pngSources = png.map((source, i) => {
      return {media: source.media, srcset: data.image_png[source.id].url, type: source.type};
    });
  }

  return [...webpSources, ...jpegSources, ...pngSources];
};

export const tileImage = (data) => {
  let image;
  if (typeof data.tile_image_jpeg !== 'undefined' && typeof data.tile_image_jpeg.url !== 'undefined') {
    image = data.tile_image_jpeg.url;
  } else if (typeof data.tile_image_png !== 'undefined' && typeof data.tile_image_png.url !== 'undefined') {
    image = data.tile_image_png.url;
  }

  return image;
};

export const tileSources = (data) => {
  let webpSources = [];
  if (typeof data.tile_image_webp !== 'undefined' && typeof data.tile_image_webp.url !== 'undefined') {
    webpSources = webp.map((source, i) => {
      return {media: source.media, srcset: data.tile_image_webp[source.id].url, type: source.type};
    });
  }
  let jpegSources = [];
  if (typeof data.tile_image_jpeg !== 'undefined' && typeof data.tile_image_jpeg.url !== 'undefined') {
    jpegSources = jpeg.map((source, i) => {
      return {media: source.media, srcset: data.tile_image_jpeg[source.id].url, type: source.type};
    });
  }
  let pngSources = [];
  if (typeof data.tile_image_png !== 'undefined' && typeof data.tile_image_png.url !== 'undefined') {
    pngSources = png.map((source, i) => {
      return {media: source.media, srcset: data.tile_image_png[source.id].url, type: source.type};
    });
  }

  return [...webpSources, ...jpegSources, ...pngSources];
};